// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application";

import SortableTableController from "./sortable_table_controller.js";
application.register("sortable-table", SortableTableController);

import SearchController from "./search_controller.js";
application.register("search", SearchController);

import NavUpgradeController from "./nav_upgrade_controller.js";
application.register("nav-upgrade", NavUpgradeController);

import JobTransactionController from "./job_transaction_controller";
application.register("job-transaction", JobTransactionController);

import CardSelectorController from "./card_selector_controller";
application.register("card-selector", CardSelectorController);

import Toggle from "./toggle_controller";
application.register("toggle", Toggle);

import JobAnnouncementFormController from "./job_announcement_form_controller.js"
application.register("job-announcement-form", JobAnnouncementFormController)

import IndexSelectableController from "./index_selectable_controller.js"
application.register("index-selectable", IndexSelectableController)

import AutoSubmitFormController from "./auto_submit_form_controller.js"
application.register("auto-submit-form", AutoSubmitFormController)

import ActiveStorageUploadController from "./active_storage_upload_controller.js"
application.register("active-storage-upload", ActiveStorageUploadController)